import { toJS, observable, computed, action, decorate } from "mobx";
import _ from 'lodash';
import idDecoder from 'lib/utils/idDecoder';
import Cookie from 'mobx-cookie';



const initialViewer = {
  _id: null,
  name: null,
  avatar: null,
  username: null,
  primaryEmailAddress: null,
  preferences: null,
  shopId: null,
  shop: {},
};

class AuthStore {
  cookie = new Cookie('portal-token');
  viewer = { ...initialViewer };
  permissions = [];

  get token() {
    console.log(this.cookie.value)
    return this.cookie.value ? this.cookie.value.split(',') : [];
  }

  setViewer(viewer){
    if (!viewer) {
      this.viewer = { ...initialViewer };
      return;
    }

    const filteredViewer = {
      ...viewer,
      __typename: undefined,
      _id: idDecoder(viewer._id),
      shopId: idDecoder(viewer.shop._id),
    }

    this.viewer = _.pickBy(filteredViewer, (value, key) => value !== undefined)
  }

  get currentViewer(){
    return this.viewer._id ? toJS(this.viewer) : null
  }
  get isLoggedIn() {
    return !!this.viewer._id;
  }
  get currentIdentity() {
    return this.token[this.token.length - 1];
  }

  changeNewIdentity(newToken) {
    const token = [...this.token];
    token.push(newToken);
    this.cookie.set(token.join(','), { expires: 7 }) // 7 day expiry
    // this.token.push(token);
  }
  backToPrevIdentity(){
    const token = [...this.token];
    token.pop();
    this.cookie.set(token.join(','), { expires: 7 }) // 7 day expiry
    // this.token.pop();
  }
  logoutAll() {
    this.cookie.remove();
    this.viewer = { ...initialViewer };
    this.permissions = [];
  }


  hasPermission(permissions){
    return this.permissions.some(p=> permissions.includes(p));
  }
  setPermission(permissions){
    this.permissions = permissions;
  }

}

decorate(AuthStore, {
  token: computed,
  isLoggedIn: computed,
  cookie: observable,
  isViewerRequested: observable,
  viewer: observable,
  setViewer: action,
  currentViewer: computed,
  changeNewIdentity: action,
  currentIdentity: computed,
  logoutAll: action,

  permissions: observable,
  hasPermission: action,
	setPermission: action,

});

export default AuthStore;
